import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import DeviationDumbView from '../../../DeviationViews/Dumbo';
import cn from 'classnames';
import s from './ExclusiveAvatar.scss';

export interface Props {
  /** The deviation to display as an exclusive avatar */
  deviation: PapiDeviation;
  /** Additional CSS class */
  className?: string;
  /** Width of the avatar */
  width?: number;
  /** Height of the avatar */
  height?: number;
}

/**
 * Small exclusive avatar component that displays a deviation thumbnail
 * Used in comment view mode to show exclusive content indicators
 */
const ExclusiveAvatar: React.FC<Props> = ({
  deviation,
  className,
  width = 32,
  height = 32,
}) => {
  return (
    <DeviationDumbView
      width={width}
      height={height}
      className={cn(s['exclusive-avatar'], className)}
      deviation={deviation}
    />
  );
};

ExclusiveAvatar.displayName = 'ExclusiveAvatar';

export default ExclusiveAvatar;
